import React from 'react';

export default function AlgovexInline({ size = 16, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ display: 'inline-block', verticalAlign: 'middle', ...style }}>
      <circle cx="48" cy="48" r="36" stroke="currentColor" strokeWidth="2" fill="none" strokeDasharray="56 170" strokeDashoffset="-24" opacity="0.8"/>
      <polyline points="18,48 28,48 33,32 40,62 47,38 54,54 60,42 68,42 74,48 78,48" stroke="currentColor" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      <circle cx="48" cy="48" r="4" fill="currentColor"/>
    </svg>
  );
}
